module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('template', {
    slot: "title"
  }, [_vm._v("Раскрытие информации")]), _vm._v(" "), _c('template', {
    slot: "section"
  }, [_c('columns', [_c('column', {
    attrs: {
      "size": "10"
    }
  }, [_c('heading', [_vm._v("Раскрытие информации субъектом рынка электроэнергии")])], 1), _vm._v(" "), _c('column', {
    attrs: {
      "size": "10"
    }
  }, [_c('p', [_vm._v("Информация, подлежащая обязательному опубликованию субъектом рынка электроэнергии в соответствии со Стандартами раскрытия информации субъектами оптового и розничных рынков электрической энергии, утвержденных "), _c('a', {
    attrs: {
      "href": "https://www.mos.ru/upload/documents/oiv/postanovlenie_ot_21_yanvarya_2004_g_24.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Постановлением Правительства РФ от 21.01.2004 № 24")])])])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "aside"
  }, [_c('aside-image', {
    attrs: {
      "image": _vm.imageBg
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c91ad3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Legal.vue
// module id = 120
// module chunks = 0